import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import ClientList from '../../components/ClientList';

const PageContainer = styled.div`
  padding: 28px 32px;
  max-width: 1600px;
  margin: 0 auto;
`;

const PageHeader = styled.div`
  margin-bottom: 24px;

  h1 {
    font-size: 1.6rem;
    font-weight: 800;
    color: #0f172a;
    margin: 0 0 4px;
    letter-spacing: -0.3px;
  }

  p {
    color: #94a3b8;
    margin: 0;
    font-size: 14px;
  }
`;

const ClientsPage = () => {
  const { t } = useTranslation();
  return (
    <PageContainer>
      <PageHeader>
        <h1>{t('clients.title')}</h1>
        <p>{t('clients.subtitle')}</p>
      </PageHeader>
      <ClientList />
    </PageContainer>
  );
};

export default ClientsPage;
